import { AiOutlineUser } from 'react-icons/ai';
import { BsCardList, BsStar } from 'react-icons/bs';

import { FeatureFlags } from '../../../../../../../../../components/Authorizer';
import { CodeStatuses } from '../../../../../../../../../constants/codes';
import { filterOperators, filterTypes } from '../../../../../../../../../redux/blueprints/search';
import { actionTypes } from '../util';

const advancedFilters = [
  {
    name: 'code',
    icon: BsStar,
    featureFlag: FeatureFlags.Codes,
    subProperties: [
      {
        entity: 'code',
        name: 'letter',
        key: 'code.letter',
        type: filterTypes.enum,
        operators: [
          filterOperators.isEqualTo
        ],
        values: [],
        idKey: 'letter',
        labelKey: 'letter'
      },
      {
        entity: 'code',
        name: 'status',
        key: 'action',
        type: filterTypes.enum,
        operators: [
          filterOperators.isEqualTo
        ],
        values: [
          { value: actionTypes.codeApplied, text: CodeStatuses.Applied },
          { value: actionTypes.codeSuggested, text: CodeStatuses.Suggested },
          { value: actionTypes.codeWaived, text: CodeStatuses.Waived },
          { value: actionTypes.codeInquiring, text: CodeStatuses.Inquiring },
          { value: actionTypes.codeRemovalSuggested, text: 'removal suggested' },
          { value: actionTypes.codeCleared, text: 'cleared' }
        ]
      },
      {
        entity: 'code',
        name: 'applied on',
        key: 'code.created_at',
        type: filterTypes.date,
        operators: [
          filterOperators.isAfter,
          filterOperators.isBefore
        ]
      }
    ]
  },
  {
    name: 'user',
    icon: AiOutlineUser,
    subProperties: [
      {
        entity: 'user',
        name: 'email',
        key: 'user.id',
        type: filterTypes.enum,
        operators: [
          filterOperators.isEqualTo
        ],
        values: [],
        idKey: 'userId',
        labelKey: 'userEmail'
      }
    ]
  },
  {
    name: 'action',
    icon: BsCardList,
    subProperties: [
      {
        entity: 'action',
        name: 'type',
        key: 'action',
        type: filterTypes.enum,
        operators: [
          filterOperators.isEqualTo
        ],
        values: Object.values(actionTypes).map(type => ({
          value: type,
          text: type.replace(/_/g, ' ')
        }))
      },
      {
        entity: 'action',
        name: 'performed on',
        key: 'created_at',
        type: filterTypes.date,
        operators: [
          filterOperators.isAfter,
          filterOperators.isBefore
        ]
      }
    ]
  }
];

export default advancedFilters;
